import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

export default function DistributedTransactions() {
    return (
        <TopicLayout
            title="Distributed transactions: 2PC vs. Saga"
            intro="Keeping data consistent across multiple services or databases when a single business operation must update more than one of them. Two-phase commit blocks until everyone agrees; a saga breaks the operation into local steps with compensations."
            diagram={
                <Diagram viewBox="0 0 560 200">
                    <text x={140} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Two-phase commit</text>
                    <Box x={95} y={30} width={100} height={36} label="Coordinator" accent/>
                    <Box x={20} y={110} width={95} height={34} label="Participant A"/>
                    <Box x={150} y={110} width={95} height={34} label="Participant B"/>
                    <Arrow x1={125} y1={66} x2={70} y2={110} label="prepare"/>
                    <Arrow x1={165} y1={66} x2={195} y2={110}/>
                    <text x={140} y={165} textAnchor="middle" fontSize={11} opacity={0.7}>vote, then commit only if everyone voted yes</text>

                    <line x1={280} y1={10} x2={280} y2={190} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={420} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Saga</text>
                    <Box x={300} y={40} width={75} height={34} label="Order"/>
                    <Box x={390} y={40} width={85} height={34} label="Payment"/>
                    <Box x={480} y={40} width={70} height={34} label="Shipping"/>
                    <Arrow x1={375} y1={57} x2={390} y2={57}/>
                    <Arrow x1={475} y1={57} x2={480} y2={57}/>
                    <Arrow x1={515} y1={92} x2={435} y2={92} label="compensate" dashed muted/>
                    <Arrow x1={435} y1={112} x2={340} y2={112} label="refund" dashed muted/>
                    <text x={420} y={165} textAnchor="middle" fontSize={11} opacity={0.7}>each step compensates the previous one on failure</text>
                </Diagram>
            }
            useWhen={[
                'Two-phase commit: all participants are close, reliable and can tolerate blocking, and true atomicity across them is worth that cost — often within a single database with distributed query support.',
                'Saga: the operation spans independently-owned services over a network, where blocking every participant on a slow coordinator is not acceptable.'
            ]}
            tradeOff="Two-phase commit gives real atomicity but every participant must hold locks and stay available until the coordinator finishes — a slow or crashed coordinator blocks everyone, and it does not scale well across services owned by different teams. Sagas avoid blocking by committing each local step immediately, but there is a window where the operation is only partially applied, and undoing a completed step requires a compensating action (a refund, a cancellation) rather than a true rollback — which is not always possible to make exact."
            ruleOfThumb="Default to sagas with idempotent steps and well-defined compensations for cross-service operations; reserve two-phase commit for tightly-coupled participants where blocking is acceptable and true atomicity is required."
        />
    )
}
